import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "gfu-success-box-stretch-goals",
  "data-qa": "payment-success:StretchGoalsSection"
}
const _hoisted_2 = {
  key: 0,
  class: "gfu-success-box-stretch-goals__col gfu-1of1 gfu-1of2--m"
}
const _hoisted_3 = { class: "gfu-hd gfu-hd--h4 _mb-6" }
const _hoisted_4 = { class: "gfu-success-box-stretch-goal-total _mb-6 _tal" }
const _hoisted_5 = { class: "gfu-hd gfu-hd--d1" }
const _hoisted_6 = { class: "gfu-progress-bar" }
const _hoisted_7 = {
  class: "gfu-success-box-stretch-goal-total__cloud gfu-cloud gfu-cloud--accent",
  "data-qa": "pledgeValue"
}
const _hoisted_8 = {
  key: 1,
  class: "gfu-success-box-stretch-goals__col gfu-1of1 gfu-1of2--m"
}
const _hoisted_9 = { class: "gfu-hd gfu-hd--h4 _mb-6" }
const _hoisted_10 = { class: "gfu-success-box-stretch-goal-item__body gfu-media__body _tal" }
const _hoisted_11 = { class: "gfu-bt gfu-bt--overline _tc--light _ttu _mt-0" }
const _hoisted_12 = {
  "format-key": "0",
  "data-qa": "stretch-goal-unlocks-at"
}
const _hoisted_13 = {
  class: "gfu-hd gfu-hd--h4 _ttu _toe",
  "data-qa": "stretch-goal-name"
}
const _hoisted_14 = { class: "gfu-success-box-stretch-goal-item__cloud gfu-cloud gfu-cloud--accent" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_localize = _resolveComponent("localize")
  const _component_themed_image = _resolveComponent("themed-image")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($options.hasFundsInfoVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h4", _hoisted_3, _toDisplayString($options.heading), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, [
              _createElementVNode("span", null, _toDisplayString($options.formattedCurrentFunds), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "gfu-progress-bar__progression gfu-progress-bar__progression--accent",
                style: _normalizeStyle($options.progressBarStyle)
              }, null, 4 /* STYLE */)
            ]),
            _createElementVNode("span", _hoisted_7, "+" + _toDisplayString($props.totalCostConverted), 1 /* TEXT */)
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ($options.hasStretchGoals)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("h4", _hoisted_9, _toDisplayString($options.stretchGoalsHeading), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.stretchGoalsModel, (stretchGoal) => {
            return (_openBlock(), _createElementBlock("div", {
              key: stretchGoal.name,
              class: "gfu-success-box-stretch-goal-item gfu-media gfu-media--middle"
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, [
                  _createVNode(_component_localize, {
                    resource: _ctx.Resources.PaymentSuccess.UnlockStretchGoalMessage
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(stretchGoal.valueFormatted), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"])
                ]),
                _createElementVNode("h4", _hoisted_13, _toDisplayString(stretchGoal.name), 1 /* TEXT */)
              ]),
              _createVNode(_component_themed_image, {
                width: "48",
                height: "48",
                src: stretchGoal.imageUrl,
                alt: _ctx.Resources.PaymentSuccess.UnlockStretchGoalImageAlt,
                class: "gfu-success-box-stretch-goal-item__side",
                loading: "lazy"
              }, null, 8 /* PROPS */, ["src", "alt"]),
              _createElementVNode("span", _hoisted_14, "+ " + _toDisplayString(stretchGoal.cloudValue), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}